import clsx from 'clsx'
import Card, {CardProps} from '../../atoms/card'

export interface ContactFormProps extends CardProps {}

export function ContactForm({className, children}: ContactFormProps) {
  return (
    <Card
      className={clsx('grid max-w-5xl mx-auto', className)}
      borderRadius="rounded-2xl md:rounded-3xl"
    >
      {children}
    </Card>
  )
}

export default ContactForm
